// The space left between segments, in percent of the circle.
const GAP = 0.8;

export type Segment = {
  // Where the segment starts, in percent of the circle from its start.
  start: number;
  // How much of the circle it draws, its trailing gap left out.
  length: number;
};

/**
 * Lays shares (0–1, summing to 1) end to end round a circle measured in
 * percent, each followed by a small gap. A share smaller than two gaps keeps
 * at least half its length, so every topic in the legend has a visible arc;
 * a single share is the whole ring, with no gap.
 */
export function segments(fractions: number[]): Segment[] {
  let start = 0;
  return fractions.map((fraction) => {
    const share = fraction * 100;
    const gap = fractions.length > 1 ? Math.min(GAP, share / 2) : 0;
    const segment = { start, length: share - gap };
    start += share;
    return segment;
  });
}
